import { Component } from 'preact';
import style from './style';

export default class Footer extends Component {
	render({ rootPath }) {
		return (
			<div class={style.footer}>
				<div class={style.footer_logo}>
					<img crossorigin="anonymous" alt="GDG Logo" src="https://firebasestorage.googleapis.com/v0/b/io-extended-android-19.appspot.com/o/gdg_logo_%20transparent_h50_tiny.png?alt=media&token=d551df03-5897-48df-8350-b92aff7b765a" />
				</div>
				<div class={style.footer_links}>
					<div class={style.footer_link}>
						<a href="https://io-extended-seoul-18.firebaseapp.com">I/O Extended Seoul 2018</a>
						<a href="https://io-extended-seoul-17.firebaseapp.com">I/O Extended Seoul 2017</a>
						<a href={rootPath + 'faq'}>FAQ</a>
						<a href={rootPath + 'coc'}>CoC</a>
					</div>					
				</div>
				<div class={style.reference}>
					<p>© 2019 Based on Project I/O Extended 2019 Kuala Lumpur PWA. Source originates from GDG KL</p>
				</div>
			</div>
			
		);
	}
}


// WEBPACK FOOTER //
// ./components/footer/index.js